import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import { ApiRoutes, type MyTenantList } from '@condo/contracts';
import { queryKeys } from '@/lib/api/query-keys';

export function useMyTenants() {
  return useQuery({
    queryKey: queryKeys.myTenants(),
    queryFn: () => api.get<MyTenantList>(ApiRoutes.meTenants),
  });
}
